(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[746],{

/***/ 1719:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteLocationEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organizationLocation_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visitAddressHide"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visitAddress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteOrganizationEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteThemeEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"theme_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFacilityEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteOrganizationEntry"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Favorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationLocationIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityLocationIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"themeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"organizationLocations"},"name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"organizationLocations","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationLocationIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteLocationEntry"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"organizationLocationsEntries"},"name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"organizations","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToEntries"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"organizationLocations","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationLocationIds"}}}]}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteOrganizationEntry"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"facilityLocations"},"name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"organizationLocations","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityLocationIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteLocationEntry"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"facilityLocationsEntries"},"name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"facilities","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToEntries"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"organizationLocations","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityLocationIds"}}}]}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFacilityEntry"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"facilities"},"name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"facilities","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFacilityEntry"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"organizations"},"name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"organizations","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteOrganizationEntry"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"themes"},"name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"themes","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"themeIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteThemeEntry"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1680}};
    doc.loc.source = {"body":"fragment FavoriteLocationEntry on organizationLocation_Entry {\n  id\n  title\n  visitAddressHide\n  visitAddress {\n    address\n    parts {\n      address\n      number\n      city\n    }\n  }\n}\n\nfragment FavoriteOrganizationEntry on organization_Entry {\n  id\n  title\n  uri\n  locations {\n    id\n  }\n}\n\nfragment FavoriteThemeEntry on theme_Entry {\n  id\n  title\n  uri\n}\n\nfragment FavoriteFacilityEntry on facility_Entry {\n  id\n  title\n  uri\n  organization {\n    ...FavoriteOrganizationEntry\n  }\n}\n\nquery Favorites(\n  $organizationLocationIds: [QueryArgument]\n  $organizationIds: [QueryArgument]\n  $facilityLocationIds: [QueryArgument]\n  $facilityIds: [QueryArgument]\n  $themeIds: [QueryArgument]\n) {\n  organizationLocations: entries(\n    section: \"organizationLocations\"\n    id: $organizationLocationIds\n  ) {\n    ...FavoriteLocationEntry\n  }\n  organizationLocationsEntries: entries(\n    section: \"organizations\"\n    relatedToEntries: [\n      { section: \"organizationLocations\", id: $organizationLocationIds }\n    ]\n  ) {\n    ...FavoriteOrganizationEntry\n  }\n  facilityLocations: entries(\n    section: \"organizationLocations\"\n    id: $facilityLocationIds\n  ) {\n    ...FavoriteLocationEntry\n  }\n  facilityLocationsEntries: entries(\n    section: \"facilities\"\n    relatedToEntries: [\n      { section: \"organizationLocations\", id: $facilityLocationIds }\n    ]\n  ) {\n    ...FavoriteFacilityEntry\n  }\n  facilities: entries(section: \"facilities\", id: $facilityIds) {\n    ...FavoriteFacilityEntry\n  }\n  organizations: entries(section: \"organizations\", id: $organizationIds) {\n    ...FavoriteOrganizationEntry\n  }\n  themes: entries(section: \"themes\", id: $themeIds) {\n    ...FavoriteThemeEntry\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.FavoriteLocationEntry = oneQuery(doc, "FavoriteLocationEntry");
        
        module.exports.FavoriteOrganizationEntry = oneQuery(doc, "FavoriteOrganizationEntry");
        
        module.exports.FavoriteThemeEntry = oneQuery(doc, "FavoriteThemeEntry");
        
        module.exports.FavoriteFacilityEntry = oneQuery(doc, "FavoriteFacilityEntry");
        
        module.exports.Favorites = oneQuery(doc, "Favorites");
        


/***/ }),

/***/ 4746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cq": function() { return /* reexport */ FavoritesApollo; },
  "eE": function() { return /* reexport */ OrganizationListingMap; },
  "sI": function() { return /* reexport */ SearchListingSidebar; }
});

// UNUSED EXPORTS: FacilitiesListingList, OrganizationListingFilters, OrganizationListingList, SearchListingListItem

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/libs/contexts/index.ts + 4 modules
var contexts = __webpack_require__(3614);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 124 modules
var ui = __webpack_require__(1015);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(3153);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var outline_esm = __webpack_require__(3801);
;// CONCATENATED MODULE: ./src/components/container/SearchListingListItem/SearchListingListItem.tsx







var SearchListingListItem = function(param) {
    var id = param.id, markerId = param.markerId, title = param.title, address = param.address, department = param.department, departmentTitle = param.departmentTitle, uri = param.uri, isLoading = param.isLoading, _isFavorite = param.isFavorite, isFavorite = _isFavorite === void 0 ? false : _isFavorite, mouseEnter = param.mouseEnter, mouseLeave = param.mouseLeave, onFavoriteClick = param.onFavoriteClick;
    return isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block border-b border-gray-200 px-8 py-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-1 flex-row justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Skeleton */.Od, {
                            className: "w-56 h-4 mb-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Skeleton */.Od, {
                            className: "w-6 h-6"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Skeleton */.Od, {
                    className: "w-32 h-2 mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Skeleton */.Od, {
                    className: "w-20 h-2"
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("block border-b border-gray-200 px-8 py-4 group hover:bg-gray-100", {}),
        onMouseEnter: function($event) {
            return mouseEnter($event, markerId);
        },
        onMouseLeave: function($event) {
            return mouseLeave($event, markerId);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-start justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                            level: 7,
                            as: "h3",
                            className: "group-hover:underline text-powerblue font-semibold",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat(uri),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/".concat(uri),
                                    title: "Lees meer over ".concat(title),
                                    children: title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm text-gray-500",
                            title: "Bezoekadres ".concat(title),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LocationMarkerIcon */.IS8, {
                                    className: "inline align-text-top w-4 h-4 mr-1"
                                }),
                                address
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm text-gray-500",
                            title: departmentTitle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* OfficeBuildingIcon */.Pf7, {
                                    className: "inline align-text-top w-4 h-4 mr-1"
                                }),
                                department
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: classnames_default()("ml-4 transform transition-transform duration-200 active:scale-125", {
                        "text-hotpink": isFavorite,
                        "text-gray-400 hover:text-hotpink": !isFavorite
                    }),
                    title: isFavorite ? "Verwijder uit favorieten" : "Opslaan in favorieten",
                    onClick: function($event) {
                        return onFavoriteClick($event, markerId);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* HeartIcon */.h_8, {
                        className: "w-6"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/container/SearchListingListItem/index.ts


;// CONCATENATED MODULE: ./src/components/container/FacilitiesListingList/FacilitiesListingList.tsx




var loadingArray = new Array(20).fill(0);
var FacilitiesListingList = function(param) {
    var entries = param.entries, isLoading = param.isLoading, onHover = param.onHover;
    var ref5 = (0,contexts/* useFavorites */.rc)(), toggleFavorite = ref5.toggleFavorite, favorites = ref5.favorites;
    var onClickFavorite = function($event, id) {
        toggleFavorite(contexts/* FAVORITE_TYPE.FACILITY_LOCATION */.RN.FACILITY_LOCATION, id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: isLoading ? loadingArray.map(function(entry, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchListingListItem, {
                    isLoading: true
                })
            }, "facility_result_loader_".concat(index));
        }) : entries === null || entries === void 0 ? void 0 : entries.map(function(entry, index) {
            var ref, ref1, ref2, ref3, ref4;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchListingListItem, {
                    isLoading: false,
                    markerId: entry === null || entry === void 0 ? void 0 : entry.id,
                    id: entry === null || entry === void 0 ? void 0 : (ref = entry.facility) === null || ref === void 0 ? void 0 : ref.id,
                    title: entry === null || entry === void 0 ? void 0 : (ref1 = entry.facility) === null || ref1 === void 0 ? void 0 : ref1.title,
                    uri: entry === null || entry === void 0 ? void 0 : (ref2 = entry.facility) === null || ref2 === void 0 ? void 0 : ref2.uri,
                    department: (entry === null || entry === void 0 ? void 0 : (ref3 = entry.facility) === null || ref3 === void 0 ? void 0 : ref3.organization[0]).title,
                    departmentTitle: "Aangeboden door ".concat((entry === null || entry === void 0 ? void 0 : (ref4 = entry.facility) === null || ref4 === void 0 ? void 0 : ref4.organization[0]).title),
                    address: "".concat(entry === null || entry === void 0 ? void 0 : entry.visitAddress.parts.address, " ").concat(entry === null || entry === void 0 ? void 0 : entry.visitAddress.parts.number, ", ").concat(entry === null || entry === void 0 ? void 0 : entry.visitAddress.parts.city),
                    mouseEnter: function($event, entryId) {
                        return onHover(entryId);
                    },
                    mouseLeave: function($event, entryId) {
                        return onHover(null);
                    },
                    onFavoriteClick: onClickFavorite,
                    isFavorite: favorites[contexts/* FAVORITE_TYPE.FACILITY_LOCATION */.RN.FACILITY_LOCATION].includes(entry.id)
                })
            }, "facility_result_".concat(index));
        })
    });
};

;// CONCATENATED MODULE: ./src/components/container/FacilitiesListingList/index.ts


// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 3 modules
var useQuery = __webpack_require__(5850);
// EXTERNAL MODULE: ./src/graphql/queries/favorites.gql
var queries_favorites = __webpack_require__(1719);
var favorites_default = /*#__PURE__*/__webpack_require__.n(queries_favorites);
// EXTERNAL MODULE: ./src/libs/apollo/index.ts + 2 modules
var apollo = __webpack_require__(8998);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/container/FavoritesListing/FavoritesListingContainer.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var combineLocationsWithOrganizations = function(locations, organizations) {
    return locations === null || locations === void 0 ? void 0 : locations.map(function(location) {
        return _objectSpread({}, location, {
            organization: organizations === null || organizations === void 0 ? void 0 : organizations.find(function(organization) {
                return organization.locations.find(function(orgLocation) {
                    return orgLocation.id === location.id;
                });
            })
        });
    });
};
var combineLocationsWithFacilities = function(locations, facilities) {
    return locations === null || locations === void 0 ? void 0 : locations.map(function(location) {
        return _objectSpread({}, location, {
            facility: facilities === null || facilities === void 0 ? void 0 : facilities.find(function(facility) {
                var ref;
                return (ref = facility === null || facility === void 0 ? void 0 : facility.organization) === null || ref === void 0 ? void 0 : ref.find(function(organization) {
                    return organization === null || organization === void 0 ? void 0 : organization.locations.find(function(orgLocation) {
                        return orgLocation.id === location.id;
                    });
                });
            })
        });
    });
};
var FavoritesListingContainer = function(param) {
    var data = param.data, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    var ref9, ref1, ref2, ref3, ref4;
    var favorites = {
        themes: data === null || data === void 0 ? void 0 : data.themes,
        organizations: data === null || data === void 0 ? void 0 : data.organizations,
        facilities: data === null || data === void 0 ? void 0 : data.facilities,
        organizationLocations: combineLocationsWithOrganizations(data === null || data === void 0 ? void 0 : data.organizationLocations, data === null || data === void 0 ? void 0 : data.organizationLocationsEntries),
        facilityLocations: combineLocationsWithFacilities(data === null || data === void 0 ? void 0 : data.facilityLocations, data === null || data === void 0 ? void 0 : data.facilityLocationsEntries)
    };
    if (isLoading) {
        return null;
    }
    var ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (favorites === null || favorites === void 0 ? void 0 : (ref9 = favorites.organizations) === null || ref9 === void 0 ? void 0 : ref9.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                        level: 3,
                        className: "mb-4",
                        children: "Organisaties"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: favorites === null || favorites === void 0 ? void 0 : favorites.organizations.map(function(organization, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (ref5 = organization === null || organization === void 0 ? void 0 : organization.uri) !== null && ref5 !== void 0 ? ref5 : "",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Link */.rU, {
                                        color: "powerblue",
                                        customUnderline: true,
                                        children: organization === null || organization === void 0 ? void 0 : organization.title
                                    })
                                })
                            }, "fav_organization_".concat(index));
                        })
                    })
                ]
            }),
            (favorites === null || favorites === void 0 ? void 0 : (ref1 = favorites.organizationLocations) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                        level: 3,
                        className: "mb-4",
                        children: "Organisaties (locaties)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: favorites === null || favorites === void 0 ? void 0 : favorites.organizationLocations.map(function(location, index) {
                            var ref, ref8;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (ref6 = location === null || location === void 0 ? void 0 : (ref = location.organization) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref6 !== void 0 ? ref6 : "",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Link */.rU, {
                                        color: "powerblue",
                                        customUnderline: true,
                                        children: [
                                            (ref8 = location.organization) === null || ref8 === void 0 ? void 0 : ref8.title,
                                            " ",
                                            location.visitAddressHide === false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    ", locatie ",
                                                    location.visitAddress.address
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, "fav_organization_location_".concat(index));
                        })
                    })
                ]
            }),
            (favorites === null || favorites === void 0 ? void 0 : (ref2 = favorites.facilities) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                        level: 3,
                        className: "mb-4",
                        children: "Hulpaanbod"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: favorites === null || favorites === void 0 ? void 0 : favorites.facilities.map(function(facility, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (facility === null || facility === void 0 ? void 0 : facility.uri) || "/",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Link */.rU, {
                                        color: "powerblue",
                                        customUnderline: true,
                                        children: facility === null || facility === void 0 ? void 0 : facility.title
                                    })
                                })
                            }, "fav_facility_".concat(index));
                        })
                    })
                ]
            }),
            (favorites === null || favorites === void 0 ? void 0 : (ref3 = favorites.facilityLocations) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                        level: 3,
                        className: "mb-4",
                        children: "Hulpaanbod (locaties)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: favorites === null || favorites === void 0 ? void 0 : favorites.facilityLocations.map(function(location, index) {
                            var ref, ref10;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (ref7 = location === null || location === void 0 ? void 0 : (ref = location.facility) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref7 !== void 0 ? ref7 : "/",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Link */.rU, {
                                        color: "powerblue",
                                        customUnderline: true,
                                        children: [
                                            (ref10 = location.facility) === null || ref10 === void 0 ? void 0 : ref10.title,
                                            ", locatie ",
                                            location.title
                                        ]
                                    })
                                })
                            }, "fav_facility_location_".concat(index));
                        })
                    })
                ]
            }),
            (favorites === null || favorites === void 0 ? void 0 : (ref4 = favorites.themes) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                        level: 3,
                        className: "mb-4",
                        children: "Onderwerpen"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: (favorites === null || favorites === void 0 ? void 0 : favorites.themes).map(function(theme, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: theme.uri,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Link */.rU, {
                                        color: "powerblue",
                                        customUnderline: true,
                                        children: theme.title
                                    })
                                })
                            }, "fav_page_".concat(index));
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/container/FavoritesListing/apollo.tsx







var FavoritesApollo = function() {
    var router = (0,next_router.useRouter)();
    var favorites = (0,contexts/* useFavorites */.rc)().favorites;
    var _ORGANIZATION_LOCATION, _FACILITY_LOCATION, _ORGANIZATION, _FACILITY, _THEME;
    var ref = (0,useQuery/* useQuery */.a)((favorites_default()), {
        notifyOnNetworkStatusChange: true,
        variables: {
            organizationLocationIds: (_ORGANIZATION_LOCATION = favorites[contexts/* FAVORITE_TYPE.ORGANIZATION_LOCATION */.RN.ORGANIZATION_LOCATION]) !== null && _ORGANIZATION_LOCATION !== void 0 ? _ORGANIZATION_LOCATION : [],
            facilityLocationIds: (_FACILITY_LOCATION = favorites[contexts/* FAVORITE_TYPE.FACILITY_LOCATION */.RN.FACILITY_LOCATION]) !== null && _FACILITY_LOCATION !== void 0 ? _FACILITY_LOCATION : [],
            organizationIds: (_ORGANIZATION = favorites[contexts/* FAVORITE_TYPE.ORGANIZATION */.RN.ORGANIZATION]) !== null && _ORGANIZATION !== void 0 ? _ORGANIZATION : [],
            facilityIds: (_FACILITY = favorites[contexts/* FAVORITE_TYPE.FACILITY */.RN.FACILITY]) !== null && _FACILITY !== void 0 ? _FACILITY : [],
            themeIds: (_THEME = favorites[contexts/* FAVORITE_TYPE.THEME */.RN.THEME]) !== null && _THEME !== void 0 ? _THEME : []
        },
        skip: !router.isReady
    }), data = ref.data, networkStatus = ref.networkStatus;
    var isLoading = (0,apollo/* getNetworkStatusDetails */.Xr)(networkStatus).isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoritesListingContainer, {
        data: data,
        isLoading: isLoading
    });
};

;// CONCATENATED MODULE: ./src/components/container/FavoritesListing/index.ts


// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2580);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
;// CONCATENATED MODULE: ./src/components/container/OrganizationListingFilters/OrganizationListingFilters.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var searchValidationSchema = es/* object */.Ry().shape({
    query: es/* string */.Z_().max(30, "Zoekterm is te lang"),
    postalCode: es/* string */.Z_().matches(/\d{4}[ ]?[A-Z]{2}/g, "Ongeldige postcode")
});
var OrganizationListingFilters = /*#__PURE__*/ (0,react.memo)(function(param1) {
    var data = param1.data, isLoading = param1.isLoading, onSubmit = param1.onSubmit;
    var ref7, ref1;
    var ref2 = (0,contexts/* useSearchFilters */.Sr)(), filters = ref2.filters, addFilter = ref2.addFilter, removeFilter = ref2.removeFilter, resetFilters = ref2.resetFilters, getFilterValue = ref2.getFilterValue, getFilterSingleValue = ref2.getFilterSingleValue;
    var setOrganizationCategoryFilter = (0,react.useCallback)(function(categoryId) {
        if (categoryId) {
            var addedCategory = data.organizationCategories.find(function(category) {
                return category.id === categoryId;
            });
            var _title;
            var label = (_title = addedCategory.title) !== null && _title !== void 0 ? _title : "Onbekend";
            addFilter("organizationCategory", categoryId, label, true);
        } else {
            removeFilter("organizationCategory");
        }
    }, [
        addFilter,
        removeFilter,
        data
    ]);
    var setServiceCategoryFilter = (0,react.useCallback)(function(categoryId) {
        if (categoryId) {
            var addedCategory = data.serviceCategories.find(function(category) {
                return category.id === categoryId;
            });
            var _title;
            var label = (_title = addedCategory.title) !== null && _title !== void 0 ? _title : "Onbekend";
            addFilter("serviceCategory", categoryId, label, true);
        } else {
            removeFilter("serviceCategory");
        }
    }, [
        addFilter,
        removeFilter,
        data
    ]);
    var setRadiusFilter = (0,react.useCallback)(function(radius) {
        addFilter("radius", radius, "".concat(radius, "km"), true);
    }, [
        addFilter
    ]);
    var searchForm = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            query: "",
            postalCode: "",
            radius: "",
            organizationCategory: "",
            serviceCategory: ""
        },
        validationSchema: searchValidationSchema,
        onSubmit: function(values) {
            Object.entries(values).map(function(param) {
                var _param = _slicedToArray(param, 2), name = _param[0], value = _param[1];
                if (value) {
                    if (name === "postalCode") {
                        addFilter(name, value, "Postcode: ".concat(value), true);
                        addFilter("radius", "20", "20km", true);
                    } else {
                        addFilter(name, value, value, true);
                    }
                } else {
                    removeFilter(name, value);
                }
            });
            onSubmit();
        }
    });
    (0,react.useEffect)(function() {
        var ref;
        searchForm.setFieldValue("query", (ref = getFilterSingleValue("query")) !== null && ref !== void 0 ? ref : "");
        var ref3;
        searchForm.setFieldValue("postalCode", (ref3 = getFilterSingleValue("postalCode")) !== null && ref3 !== void 0 ? ref3 : "");
        var ref4;
        searchForm.setFieldValue("radius", (ref4 = getFilterSingleValue("radius")) !== null && ref4 !== void 0 ? ref4 : "");
        var ref5;
        searchForm.setFieldValue("organizationCategory", (ref5 = getFilterSingleValue("organizationCategory")) !== null && ref5 !== void 0 ? ref5 : "");
        var ref6;
        searchForm.setFieldValue("serviceCategory", (ref6 = getFilterSingleValue("serviceCategory")) !== null && ref6 !== void 0 ? ref6 : "");
    }, [
        filters
    ]);
    var resetForm = (0,react.useCallback)(function() {
        searchForm.resetForm();
        resetFilters();
    }, []);
    var emptyListBoxItem = {
        id: null,
        value: null,
        name: "Selecteer"
    };
    var organizationCategoryListBoxData = [
        emptyListBoxItem, 
    ].concat((ref7 = data.organizationCategories) === null || ref7 === void 0 ? void 0 : ref7.map(function(category) {
        return {
            id: category.id,
            value: category.id,
            name: category.title
        };
    }));
    var serviceCategoryListBoxData = [
        emptyListBoxItem, 
    ].concat((ref1 = data.serviceCategories) === null || ref1 === void 0 ? void 0 : ref1.map(function(category) {
        return {
            id: category.id,
            value: category.id,
            name: category.title
        };
    }));
    if (isLoading) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: searchForm.handleSubmit,
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "border-b border-b-gray p-8 pt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: classnames_default()("text-xs", {
                                "text-gray-700": !searchForm.errors.query,
                                "text-red-700": searchForm.errors.query
                            }),
                            htmlFor: "query",
                            children: searchForm.errors.query ? searchForm.errors.query : "Zoekterm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* FormInput */.yt, {
                            name: "query",
                            placeholder: "",
                            onChange: searchForm.handleChange,
                            value: searchForm.values.query
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row border-b border-gray-100 p-8 pt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-32 mr-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: classnames_default()("text-xs", {
                                        "text-gray-700": !searchForm.errors.postalCode,
                                        "text-red-700": searchForm.errors.postalCode
                                    }),
                                    htmlFor: "postalCode",
                                    children: searchForm.errors.postalCode ? searchForm.errors.postalCode : "Postcode"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* FormInput */.yt, {
                                    name: "postalCode",
                                    placeholder: "",
                                    onChange: searchForm.handleChange,
                                    value: searchForm.values.postalCode
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-32 relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "text-xs text-gray-700",
                                    htmlFor: "radius",
                                    children: "Afstand"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* FormListbox */.Xw, {
                                    data: [
                                        10,
                                        20,
                                        30,
                                        50,
                                        100
                                    ].map(function(radius) {
                                        return {
                                            id: radius.toString(),
                                            value: radius.toString(),
                                            name: "".concat(radius, "km")
                                        };
                                    }),
                                    value: searchForm.values.radius,
                                    onChange: setRadiusFilter
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "border-b border-b-gray p-8 pt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: "text-xs text-gray-700",
                            htmlFor: "postalCode",
                            children: "Soort organisatie"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* FormListbox */.Xw, {
                            data: organizationCategoryListBoxData,
                            value: searchForm.values.organizationCategory,
                            onChange: setOrganizationCategoryFilter
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "border-b border-b-gray p-8 pt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: "text-xs text-gray-700",
                            htmlFor: "postalCode",
                            children: "Soort aanbod"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* FormListbox */.Xw, {
                            data: serviceCategoryListBoxData,
                            value: searchForm.values.serviceCategory,
                            onChange: setServiceCategoryFilter
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center p-8 pt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                            type: "submit",
                            color: "powerblue",
                            appearance: "solid",
                            size: "sm",
                            children: "Filters toepassen"
                        }),
                        filters.size > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                            color: "hotpink",
                            appearance: "outline",
                            size: "sm",
                            className: "ml-2",
                            onClick: resetForm,
                            children: "Filters wissen"
                        })
                    ]
                })
            ]
        })
    });
});
OrganizationListingFilters.displayName = "OrganizationListingFilterBar";

;// CONCATENATED MODULE: ./src/components/container/OrganizationListingFilters/index.ts


;// CONCATENATED MODULE: ./src/components/container/OrganizationListingList/OrganizationListingList.tsx




var OrganizationListingList_loadingArray = new Array(20).fill(0);
var OrganizationListingList = function(param) {
    var entries = param.entries, isLoading = param.isLoading, onHover = param.onHover;
    var ref2 = (0,contexts/* useFavorites */.rc)(), toggleFavorite = ref2.toggleFavorite, favorites = ref2.favorites;
    var onClickFavorite = function($event, id) {
        toggleFavorite(contexts/* FAVORITE_TYPE.ORGANIZATION_LOCATION */.RN.ORGANIZATION_LOCATION, id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: isLoading ? OrganizationListingList_loadingArray.map(function(entry, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchListingListItem, {
                    isLoading: true
                })
            }, "organization_result_loader_".concat(index));
        }) : entries === null || entries === void 0 ? void 0 : entries.map(function(entry, index) {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchListingListItem, {
                    isLoading: false,
                    markerId: entry === null || entry === void 0 ? void 0 : entry.id,
                    id: entry === null || entry === void 0 ? void 0 : entry.id,
                    title: entry === null || entry === void 0 ? void 0 : (ref = entry.organization) === null || ref === void 0 ? void 0 : ref.title,
                    uri: entry === null || entry === void 0 ? void 0 : (ref1 = entry.organization) === null || ref1 === void 0 ? void 0 : ref1.uri,
                    department: entry === null || entry === void 0 ? void 0 : entry.title,
                    departmentTitle: "Locatie ".concat(entry === null || entry === void 0 ? void 0 : entry.title),
                    address: "".concat(entry === null || entry === void 0 ? void 0 : entry.visitAddress.parts.address, " ").concat(entry === null || entry === void 0 ? void 0 : entry.visitAddress.parts.number, ", ").concat(entry === null || entry === void 0 ? void 0 : entry.visitAddress.parts.city),
                    mouseEnter: function($event, entryId) {
                        return onHover(entryId);
                    },
                    mouseLeave: function($event, entryId) {
                        return onHover(null);
                    },
                    onFavoriteClick: onClickFavorite,
                    isFavorite: favorites[contexts/* FAVORITE_TYPE.ORGANIZATION_LOCATION */.RN.ORGANIZATION_LOCATION].includes(entry.id)
                })
            }, "organization_result_".concat(index));
        })
    });
};

;// CONCATENATED MODULE: ./src/components/container/OrganizationListingList/index.ts


// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var dist_esm = __webpack_require__(7054);
;// CONCATENATED MODULE: ./src/components/container/OrganizationListingMap/OrganizationListingMap.tsx







var center = {
    lat: 52.4395737,
    lng: 6.5126433
};
var setMarkerIcon = function(marker) {
    marker.setIcon({
        path: "M96.571,90.9886 C104.93,81.3416 110,68.7666 110,54.9996 C110,24.6236 85.375,-0.0004 55,-0.0004 C24.624,-0.0004 0,24.6236 0,54.9996 C0,68.7666 5.07,81.3416 13.429,90.9886 L13.418,90.9996 L13.572,91.1536 C15.209,93.0286 16.971,94.7906 18.846,96.4276 L55,132.5816 L91.156,96.4266 C93.029,94.7896 94.79,93.0296 96.426,91.1556 L96.582,90.9996 L96.571,90.9886 Z",
        fillColor: "#ff0000",
        fillOpacity: 1,
        scale: 0.2,
        strokeColor: "#FFF",
        strokeWeight: 1,
        strokeOpacity: 1,
        anchor: new window.google.maps.Point(55, 132)
    });
};
var getMarkerInfoWindow = function(entry) {
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "pt-1 pb-2 px-2 font-body ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "font-semibold text-powerblue text-xl mb-2",
                children: entry.title
            }),
            (entry === null || entry === void 0 ? void 0 : (ref = entry.address) === null || ref === void 0 ? void 0 : ref.address) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm text-gray-500",
                title: "Bezoekadres ".concat(entry.title),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LocationMarkerIcon */.IS8, {
                            className: "inline align-text-top w-4 h-4 mr-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inline",
                            children: [
                                entry === null || entry === void 0 ? void 0 : (ref1 = entry.address) === null || ref1 === void 0 ? void 0 : ref1.address,
                                " ",
                                entry === null || entry === void 0 ? void 0 : (ref2 = entry.address) === null || ref2 === void 0 ? void 0 : ref2.number,
                                ",",
                                " ",
                                entry === null || entry === void 0 ? void 0 : (ref3 = entry.address) === null || ref3 === void 0 ? void 0 : ref3.city
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var OrganizationListingMap = /*#__PURE__*/ (0,react.memo)(function(param) {
    var markers = param.entries, isLoading = param.isLoading, selectedLocation = param.selectedLocation;
    var mapRef = (0,react.useRef)(null);
    var ref = (0,dist_esm/* useJsApiLoader */.Ji)({
        id: "google-map-script",
        version: "weekly",
        googleMapsApiKey: "AIzaSyALAoCzT99hIXU-2VR94P8Bdhz2xp4IWXY",
        preventGoogleFontsLoading: false
    }), isGoogleMapsLoaded = ref.isLoaded, googleMapsLoadError = ref.loadError;
    var ref4 = (0,react.useState)(null), map1 = ref4[0], setMap = ref4[1];
    var ref5 = (0,react.useState)(null), selectedMapEntry = ref5[0], setSelectedMapEntry = ref5[1];
    var ref6 = (0,react.useState)(false), infoBoxFixed = ref6[0], setInfoBoxFixed = ref6[1];
    var ref7 = (0,react.useState)(false), infoBoxOpen = ref7[0], setInfoBoxOpen = ref7[1];
    var onLoad = (0,react.useCallback)(function(map) {
        setMap(map);
    }, []);
    var onUnmount = (0,react.useCallback)(function(map) {
        setMap(null);
    }, []);
    var onMarkerClick = (0,react.useCallback)(function(event) {
        setInfoBoxFixed(!infoBoxFixed);
    }, [
        infoBoxFixed
    ]);
    var onMarkerMouseMove = (0,react.useCallback)(function(event, entry) {
        if (infoBoxFixed && selectedMapEntry.id !== entry.id) {
            setInfoBoxFixed(false);
        }
        setSelectedMapEntry(entry);
        setInfoBoxOpen(true);
    }, [
        infoBoxFixed,
        setSelectedMapEntry,
        setInfoBoxOpen,
        setInfoBoxFixed
    ]);
    var onMarkerMouseOut = (0,react.useCallback)(function(event) {
        if (!infoBoxFixed) {
            setInfoBoxOpen(false);
        }
    }, [
        setInfoBoxOpen,
        infoBoxFixed
    ]);
    var closeInfoWindow = (0,react.useCallback)(function() {
        setInfoBoxFixed(false);
        setInfoBoxOpen(false);
    }, [
        setInfoBoxOpen,
        setInfoBoxFixed
    ]);
    // Fit bounds function
    var fitBounds = function() {
        if (markers.length > 0) {
            var bounds = new window.google.maps.LatLngBounds();
            markers === null || markers === void 0 ? void 0 : markers.map(function(item) {
                bounds.extend({
                    lat: item.lat,
                    lng: item.lng
                });
                return item.id;
            });
            map1 && map1.fitBounds(bounds);
        }
    };
    (0,react.useEffect)(function() {
        if (markers) {
            setInfoBoxOpen(false);
            setInfoBoxFixed(false);
            fitBounds();
        }
    }, [
        markers,
        setInfoBoxOpen,
        setInfoBoxFixed
    ]);
    if (googleMapsLoadError) {
        // eslint-disable-next-line no-console
        console.log("error", googleMapsLoadError);
        return null;
    }
    if (!isGoogleMapsLoaded) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full top-0 right-0 bottom-0 left-0 bg-white bg-opacity-40 z-30 transition-all duration-300 flex flex-col items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Spinner */.$j, {
                    radius: 40,
                    thickness: 4,
                    className: "text-powerblue"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_esm/* GoogleMap */.b6, {
                ref: mapRef,
                mapContainerClassName: "w-full h-full",
                center: center,
                zoom: 12,
                onLoad: onLoad,
                onUnmount: onUnmount,
                onClick: closeInfoWindow,
                options: {
                    scrollwheel: false,
                    disableDefaultUI: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    zoomControl: true,
                    styles: [
                        {
                            featureType: "poi",
                            elementType: "labels.icon",
                            stylers: [
                                {
                                    visibility: "off"
                                }, 
                            ]
                        }, 
                    ]
                },
                children: [
                    !isLoading && (markers === null || markers === void 0 ? void 0 : markers.map(function(entry, index) {
                        var isActive = entry.id === selectedLocation;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* Marker */.Jx, {
                            // label={{
                            //   text: 'A',
                            //   color: '#ffffff',
                            //   fontSize: isActive ? '1.4rem' : '0.8rem',
                            // }}
                            position: {
                                lat: entry.lat,
                                lng: entry.lng
                            },
                            title: entry.title,
                            onMouseOver: function(event) {
                                return onMarkerMouseMove(event, entry);
                            },
                            onMouseOut: onMarkerMouseOut,
                            onClick: onMarkerClick,
                            icon: {
                                path: "M96.571,90.9886 C104.93,81.3416 110,68.7666 110,54.9996 C110,24.6236 85.375,-0.0004 55,-0.0004 C24.624,-0.0004 0,24.6236 0,54.9996 C0,68.7666 5.07,81.3416 13.429,90.9886 L13.418,90.9996 L13.572,91.1536 C15.209,93.0286 16.971,94.7906 18.846,96.4276 L55,132.5816 L91.156,96.4266 C93.029,94.7896 94.79,93.0296 96.426,91.1556 L96.582,90.9996 L96.571,90.9886 Z",
                                fillColor: isActive ? "#F26E21" : "#2a378d",
                                fillOpacity: 1,
                                scale: isActive ? 0.35 : 0.2,
                                strokeColor: "#FFF",
                                strokeWeight: isActive ? 2 : 1,
                                strokeOpacity: 1,
                                anchor: new window.google.maps.Point(55, 132),
                                labelOrigin: isActive ? new window.google.maps.Point(54, 54) : new window.google.maps.Point(54, 54)
                            },
                            zIndex: isActive ? 1000 : undefined
                        }, "google_maps_marker_".concat(entry.id, "_").concat(index));
                    })),
                    infoBoxOpen && selectedMapEntry && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* InfoBox */.vD, {
                        position: new window.google.maps.LatLng({
                            lat: selectedMapEntry.lat,
                            lng: selectedMapEntry.lng
                        }),
                        options: {
                            boxClass: "w-96 bg-white rounded-sm shadow-lg p-4",
                            maxWidth: 384,
                            alignBottom: true,
                            pixelOffset: new window.google.maps.Size(-192, infoBoxFixed ? -34 : -34),
                            infoBoxClearance: new window.google.maps.Size(20, 20),
                            closeBoxURL: null,
                            enableEventPropagation: true
                        },
                        onCloseClick: closeInfoWindow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("font-body transform transition-all duration-200", {
                                "translate-y-0 mt-0": infoBoxFixed
                            }, {
                                "translate-y-16 -mt-16": !infoBoxFixed
                            }),
                            children: [
                                getMarkerInfoWindow(selectedMapEntry),
                                selectedMapEntry.uri && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/".concat(selectedMapEntry.uri),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                                        as: "a",
                                        color: "powerblue",
                                        size: "sm",
                                        appearance: "solid",
                                        fullWidth: true,
                                        className: "mt-5",
                                        title: "Lees meer over ".concat(selectedMapEntry.title),
                                        children: "Naar detailpagina"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
});
OrganizationListingMap.displayName = "OrganizationListingMap";

;// CONCATENATED MODULE: ./src/components/container/OrganizationListingMap/index.ts


// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(8390);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(2351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(9946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(2984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(1363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(4575);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(6723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(3784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(4157);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(6045);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/internal/focus-sentinel.js
function focus_sentinel_p({onFocus:n}){let[r,o]=(0,react.useState)(!0);return r?react.createElement(internal_hidden/* Hidden */._,{as:"button",type:"button",features:internal_hidden/* Features.Focusable */.A.Focusable,onFocus:a=>{a.preventDefault();let e,u=50;function t(){if(u--<=0){e&&cancelAnimationFrame(e);return}if(n()){o(!1),cancelAnimationFrame(e);return}e=requestAnimationFrame(t)}e=requestAnimationFrame(t)}}):null}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(3781);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.js
var re=(n=>(n[n.SetSelectedIndex=0]="SetSelectedIndex",n[n.RegisterTab=1]="RegisterTab",n[n.UnregisterTab=2]="UnregisterTab",n[n.RegisterPanel=3]="RegisterPanel",n[n.UnregisterPanel=4]="UnregisterPanel",n[n.ForceRerender=5]="ForceRerender",n))(re||{});let ne={[0](e,t){let r=e.tabs.filter(n=>{var l;return!((l=n.current)!=null&&l.hasAttribute("disabled"))});if(t.index<0)return{...e,selectedIndex:e.tabs.indexOf(r[0])};if(t.index>e.tabs.length)return{...e,selectedIndex:e.tabs.indexOf(r[r.length-1])};let s=e.tabs.slice(0,t.index),d=[...e.tabs.slice(t.index),...s].find(n=>r.includes(n));return d?{...e,selectedIndex:e.tabs.indexOf(d)}:e},[1](e,t){return e.tabs.includes(t.tab)?e:{...e,tabs:(0,focus_management/* sortByDomNode */.z2)([...e.tabs,t.tab],r=>r.current)}},[2](e,t){return{...e,tabs:(0,focus_management/* sortByDomNode */.z2)(e.tabs.filter(r=>r!==t.tab),r=>r.current)}},[3](e,t){return e.panels.includes(t.panel)?e:{...e,panels:[...e.panels,t.panel]}},[4](e,t){return{...e,panels:e.panels.filter(r=>r!==t.panel)}},[5](e){return{...e}}},N=(0,react.createContext)(null);N.displayName="TabsSSRContext";function B(e){let t=(0,react.useContext)(N);if(t===null){let r=new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(r,B),r}return t}let K=(0,react.createContext)(null);K.displayName="TabsDataContext";function C(e){let t=(0,react.useContext)(K);if(t===null){let r=new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(r,C),r}return t}let $=(0,react.createContext)(null);$.displayName="TabsActionsContext";function z(e){let t=(0,react.useContext)($);if(t===null){let r=new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(r,z),r}return t}function ae(e,t){return (0,match/* match */.E)(t.type,ne,e,t)}let le=react.Fragment,oe=(0,render/* forwardRefWithAs */.yV)(function(t,r){let{defaultIndex:s=0,vertical:f=!1,manual:d=!1,onChange:n,selectedIndex:l=null,...P}=t;const u=f?"vertical":"horizontal",y=d?"manual":"auto";let c=(0,use_sync_refs/* useSyncRefs */.T)(r),[p,o]=(0,react.useReducer)(ae,{selectedIndex:l!=null?l:s,tabs:[],panels:[]}),b=(0,react.useMemo)(()=>({selectedIndex:p.selectedIndex}),[p.selectedIndex]),g=(0,use_latest_value/* useLatestValue */.E)(n||(()=>{})),L=(0,use_latest_value/* useLatestValue */.E)(p.tabs),x=(0,react.useMemo)(()=>({orientation:u,activation:y,...p}),[u,y,p]),R=(0,use_latest_value/* useLatestValue */.E)(p.selectedIndex),h=(0,react.useMemo)(()=>({registerTab(i){return o({type:1,tab:i}),()=>o({type:2,tab:i})},registerPanel(i){return o({type:3,panel:i}),()=>o({type:4,panel:i})},forceRerender(){o({type:5})},change(i){R.current!==i&&g.current(i),R.current=i,o({type:0,index:i})}}),[o]);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{o({type:0,index:l!=null?l:s})},[l]);let H=(0,react.useRef)({tabs:[],panels:[]}),w={ref:c};return react.createElement(N.Provider,{value:H},react.createElement($.Provider,{value:h},react.createElement(K.Provider,{value:x},x.tabs.length<=0&&react.createElement(focus_sentinel_p,{onFocus:()=>{var i,I;for(let D of L.current)if(((i=D.current)==null?void 0:i.tabIndex)===0)return(I=D.current)==null||I.focus(),!0;return!1}}),(0,render/* render */.sY)({ourProps:w,theirProps:P,slot:b,defaultTag:le,name:"Tabs"}))))}),se="div",ie=(0,render/* forwardRefWithAs */.yV)(function(t,r){let{orientation:s,selectedIndex:f}=C("Tab.List"),d=(0,use_sync_refs/* useSyncRefs */.T)(r);return (0,render/* render */.sY)({ourProps:{ref:d,role:"tablist","aria-orientation":s},theirProps:t,slot:{selectedIndex:f},defaultTag:se,name:"Tabs.List"})}),ue="button",ce=(0,render/* forwardRefWithAs */.yV)(function(t,r){var I,D;let s=`headlessui-tabs-tab-${(0,use_id/* useId */.M)()}`,{orientation:f,activation:d,selectedIndex:n,tabs:l,panels:P}=C("Tab"),u=z("Tab"),y=B("Tab"),c=(0,react.useRef)(null),p=(0,use_sync_refs/* useSyncRefs */.T)(c,r,a=>{!a||u.forceRerender()});(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>u.registerTab(c),[u,c]);let o=y.current.tabs.indexOf(s);o===-1&&(o=y.current.tabs.push(s)-1);let b=l.indexOf(c);b===-1&&(b=o);let g=b===n,L=(0,use_event/* useEvent */.z)(a=>{let A=l.map(X=>X.current).filter(Boolean);if(a.key===keyboard/* Keys.Space */.R.Space||a.key===keyboard/* Keys.Enter */.R.Enter){a.preventDefault(),a.stopPropagation(),u.change(b);return}switch(a.key){case keyboard/* Keys.Home */.R.Home:case keyboard/* Keys.PageUp */.R.PageUp:return a.preventDefault(),a.stopPropagation(),(0,focus_management/* focusIn */.jA)(A,focus_management/* Focus.First */.TO.First);case keyboard/* Keys.End */.R.End:case keyboard/* Keys.PageDown */.R.PageDown:return a.preventDefault(),a.stopPropagation(),(0,focus_management/* focusIn */.jA)(A,focus_management/* Focus.Last */.TO.Last)}if((0,match/* match */.E)(f,{vertical(){if(a.key===keyboard/* Keys.ArrowUp */.R.ArrowUp)return (0,focus_management/* focusIn */.jA)(A,focus_management/* Focus.Previous */.TO.Previous|focus_management/* Focus.WrapAround */.TO.WrapAround);if(a.key===keyboard/* Keys.ArrowDown */.R.ArrowDown)return (0,focus_management/* focusIn */.jA)(A,focus_management/* Focus.Next */.TO.Next|focus_management/* Focus.WrapAround */.TO.WrapAround)},horizontal(){if(a.key===keyboard/* Keys.ArrowLeft */.R.ArrowLeft)return (0,focus_management/* focusIn */.jA)(A,focus_management/* Focus.Previous */.TO.Previous|focus_management/* Focus.WrapAround */.TO.WrapAround);if(a.key===keyboard/* Keys.ArrowRight */.R.ArrowRight)return (0,focus_management/* focusIn */.jA)(A,focus_management/* Focus.Next */.TO.Next|focus_management/* Focus.WrapAround */.TO.WrapAround)}}))return a.preventDefault()}),x=(0,use_event/* useEvent */.z)(()=>{var a;(a=c.current)==null||a.focus()}),R=(0,use_event/* useEvent */.z)(()=>{var a;(a=c.current)==null||a.focus(),u.change(b)}),h=(0,use_event/* useEvent */.z)(a=>{a.preventDefault()}),H=(0,react.useMemo)(()=>({selected:g}),[g]),w=t,i={ref:p,onKeyDown:L,onFocus:d==="manual"?x:R,onMouseDown:h,onClick:R,id:s,role:"tab",type:(0,use_resolve_button_type/* useResolveButtonType */.f)(t,c),"aria-controls":(D=(I=P[b])==null?void 0:I.current)==null?void 0:D.id,"aria-selected":g,tabIndex:g?0:-1};return (0,render/* render */.sY)({ourProps:i,theirProps:w,slot:H,defaultTag:ue,name:"Tabs.Tab"})}),pe="div",de=(0,render/* forwardRefWithAs */.yV)(function(t,r){let{selectedIndex:s}=C("Tab.Panels"),f=(0,use_sync_refs/* useSyncRefs */.T)(r),d=(0,react.useMemo)(()=>({selectedIndex:s}),[s]);return (0,render/* render */.sY)({ourProps:{ref:f},theirProps:t,slot:d,defaultTag:pe,name:"Tabs.Panels"})}),fe="div",be=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static,Te=(0,render/* forwardRefWithAs */.yV)(function(t,r){var x,R;let{selectedIndex:s,tabs:f,panels:d}=C("Tab.Panel"),n=z("Tab.Panel"),l=B("Tab.Panel"),P=`headlessui-tabs-panel-${(0,use_id/* useId */.M)()}`,u=(0,react.useRef)(null),y=(0,use_sync_refs/* useSyncRefs */.T)(u,r,h=>{!h||n.forceRerender()});(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>n.registerPanel(u),[n,u]);let c=l.current.panels.indexOf(P);c===-1&&(c=l.current.panels.push(P)-1);let p=d.indexOf(u);p===-1&&(p=c);let o=p===s,b=(0,react.useMemo)(()=>({selected:o}),[o]),g=t,L={ref:y,id:P,role:"tabpanel","aria-labelledby":(R=(x=f[p])==null?void 0:x.current)==null?void 0:R.id,tabIndex:o?0:-1};return (0,render/* render */.sY)({ourProps:L,theirProps:g,slot:b,defaultTag:fe,features:be,visible:o,name:"Tabs.Panel"})}),we=Object.assign(ce,{Group:oe,List:ie,Panels:de,Panel:Te});

// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 3 modules
var hooks = __webpack_require__(7279);
;// CONCATENATED MODULE: ./src/components/container/SearchListingSidebar/SearchListingSidebar.tsx
function SearchListingSidebar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchListingSidebar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchListingSidebar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












var getAmount = function(amount) {
    return amount ? amount > 100 ? "100+" : amount.toString() : null;
};
var tabGroups = [
    {
        id: "organizations",
        title: "Organisaties",
        path: "organisaties"
    },
    {
        id: "facilities",
        title: "Hulpaanbod",
        path: "aanbod"
    }, 
];
var PAGE_SIZE = 20;
var SearchListingSidebar = /*#__PURE__*/ (0,react.memo)(function(param1) {
    var organizationsResults = param1.organizationsResults, facilitiesResults = param1.facilitiesResults, isLoadingResults = param1.isLoadingResults, isLoadingFilterData = param1.isLoadingFilterData, filterData = param1.filterData, onHover = param1.onHover, selectedTab = param1.selectedTab, onTabChange = param1.onTabChange, totalOrganizations = param1.totalOrganizations, totalFacilities = param1.totalFacilities, pageNumber = param1.pageNumber;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), hasFiltersOpen = ref[0], setHasFiltersOpen = ref[1];
    var filters = (0,contexts/* useSearchFilters */.Sr)().filters;
    var isMobile = (0,hooks/* useBreakpoints */.kC)().isMobile;
    var handleChange = function(event, value) {
        var newQuery = SearchListingSidebar_objectSpread({}, router.query, {
            params: [
                router.query.params[0],
                value.toString()
            ]
        });
        router.push({
            pathname: router.pathname,
            query: newQuery
        }, null, {
            shallow: true,
            scroll: true
        });
    };
    var openFilterPanel = function() {
        return setHasFiltersOpen(true);
    };
    var closeFilterPanel = function() {
        return setHasFiltersOpen(false);
    };
    var convertIndexToTabName = function(index) {
        onTabChange(tabGroups[index]);
    };
    if (!router.isReady) {
        return null;
    } else {
        var selectedIndex = selectedTab === "organisaties" ? 0 : 1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative min-h-screen",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(transition/* Transition */.u, {
                    show: !hasFiltersOpen,
                    enter: "transition duration-200",
                    enterFrom: "opacity-0 -translate-x-full",
                    enterTo: "opacity-100 translate-x-0",
                    leave: "transition duration-200",
                    leaveFrom: "opacity-100 translate-x-0",
                    leaveTo: "opacity-0 -translate-x-full",
                    className: "transform",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "border-b border-gray-100",
                            children: isLoadingResults ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-8 py-5 text-gray-700 text-sm flex flex-row items-end justify-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Skeleton */.Od, {
                                        className: "w-24 h-8 rounded-full mr-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Skeleton */.Od, {
                                        className: "w-36 h-8 rounded-full"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row px-8 py-4 text-gray-700 text-sm border-gray-100 items-center justify-end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Button */.zx, {
                                        size: "sm",
                                        color: "powerblue",
                                        appearance: "outline",
                                        withIcon: true,
                                        onClick: openFilterPanel,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* AdjustmentsIcon */.XgF, {
                                                className: "w-5 h-5 transform rotate-90"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Filters"
                                            }),
                                            filters.size > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "px-2 rounded-full text-xs bg-hotpink text-white",
                                                children: filters.size
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(we.Group, {
                                selectedIndex: selectedIndex,
                                onChange: convertIndexToTabName,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(we.List, {
                                        className: "flex",
                                        children: tabGroups.map(function(tab) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(we, {
                                                className: function(param) {
                                                    var selected = param.selected;
                                                    return classnames_default()("w-full py-4 font-semibold border-b-2 border-white", "focus:outline-none", selected ? "bg-white" : "bg-gradient-to-b from-gray-100 to-gray-200 text-gray-400 hover:text-gray-600");
                                                },
                                                children: function(param) {
                                                    var selected = param.selected;
                                                    return tab.id === "organizations" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            tab.title,
                                                            totalOrganizations > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Badge */.Ct, {
                                                                className: classnames_default()("bg-powerblue text-white text-xs ml-2", selected ? "bg-powerblue text-white" : "bg-gray-400 text-gray-700"),
                                                                children: getAmount(totalOrganizations)
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            tab.title,
                                                            totalFacilities > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Badge */.Ct, {
                                                                className: classnames_default()("bg-powerblue text-white text-xs ml-2", selected ? "bg-powerblue text-white" : "bg-gray-400 text-gray-700"),
                                                                children: getAmount(totalFacilities)
                                                            })
                                                        ]
                                                    });
                                                }
                                            }, "results_organizations_".concat(tab.id));
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(we.Panels, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(we.Panel, {
                                                className: classnames_default()("focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-1 px-8 py-4 text-gray-700 text-sm border-b border-gray-100 items-center justify-between",
                                                        children: isLoadingResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Skeleton */.Od, {
                                                            className: "w-72 h-3 my-1"
                                                        }) : totalOrganizations > 100 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Meer dan 100 gevonden organisaties"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                totalOrganizations,
                                                                " gevonden organisaties"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationListingList, {
                                                        entries: organizationsResults,
                                                        isLoading: isLoadingResults,
                                                        onHover: onHover
                                                    }),
                                                    totalOrganizations > PAGE_SIZE && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Pagination */.tl, {
                                                        count: Math.ceil(totalOrganizations / PAGE_SIZE),
                                                        page: pageNumber,
                                                        boundaryCount: 0,
                                                        onChange: handleChange,
                                                        isLoading: isLoadingResults,
                                                        hidePrevButton: isMobile
                                                    })
                                                ]
                                            }, "tab_panel_results_organizations"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(we.Panel, {
                                                className: classnames_default()("focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-1 px-8 py-4 text-gray-700 text-sm border-b border-gray-100 items-center justify-between",
                                                        children: isLoadingResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Skeleton */.Od, {
                                                            className: "w-72 h-3 my-1"
                                                        }) : totalFacilities > 100 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Meer dan 100 resultaten gevonden in het hulpaanbod"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                totalFacilities,
                                                                " resultaten gevonden in het hulpaanbod"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilitiesListingList, {
                                                        entries: facilitiesResults,
                                                        isLoading: isLoadingResults,
                                                        onHover: onHover
                                                    }),
                                                    totalFacilities > PAGE_SIZE && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Pagination */.tl, {
                                                        count: Math.ceil(totalFacilities / PAGE_SIZE),
                                                        page: pageNumber,
                                                        boundaryCount: 0,
                                                        onChange: handleChange,
                                                        isLoading: isLoadingResults,
                                                        hidePrevButton: isMobile
                                                    })
                                                ]
                                            }, "tab_panel_results_facilities")
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(transition/* Transition */.u, {
                    show: hasFiltersOpen,
                    enter: "transition duration-200",
                    enterFrom: "opacity-0 translate-x-full",
                    enterTo: "opacity-100 translate-x-0",
                    leave: "transition duration-200",
                    leaveFrom: "opacity-100 translate-x-0",
                    leaveTo: "opacity-0 translate-x-full",
                    className: "absolute top-0 left-0 right-0 bottom-0 transform",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "border-b border-gray-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex px-8 py-4 text-gray-700 text-sm justify-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Button */.zx, {
                                    size: "sm",
                                    color: "powerblue",
                                    appearance: "outline",
                                    withIcon: true,
                                    onClick: closeFilterPanel,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ArrowLeftIcon */.Y4O, {
                                            className: "w-5 h-5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Terug naar resultaten"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationListingFilters, {
                            data: filterData,
                            isLoading: isLoadingFilterData,
                            onSubmit: closeFilterPanel
                        })
                    ]
                })
            ]
        });
    }
});
SearchListingSidebar.displayName = "SearchListingSidebar";

;// CONCATENATED MODULE: ./src/components/container/SearchListingSidebar/index.ts


;// CONCATENATED MODULE: ./src/components/container/index.ts









/***/ })

}]);